/* eslint-disable camelcase */
import { IFilters } from '../../_models/commonInterface'
import {
  IAddBusinessFilters,
  IBusinessIdParam,
  IBusinessStatusParams,
  IEditBusiness,
  IProfileData,
} from '../../_models/superAdmin/businessInterface'
import { _delete, get, post, postFileData, put } from './../apiServices'

export const addBusiness = async (IAddBusinessFilters: IAddBusinessFilters) => {
  const response = postFileData('super-admin/business', IAddBusinessFilters)
  return response
}
export const getBusinessDetails = async (businessId: IBusinessIdParam) => {
  const response = get('super-admin/business', {
    business_id: businessId.businessId,
  })
  return response
}
export const switchSuperAdminBusinessList = async (filters?: IFilters) => {
  const response = await get('super-admin/switch-business/list', filters)
  return response
}

export const switchProfile = async (profileData: IProfileData) => {
  const response = await post('super-admin/switch-business', profileData)
  return response
}
export const editBusiness = async (editParams: IEditBusiness) => {
  const response = postFileData('super-admin/business', editParams)
  return response
}
export const getSuperAdminBusinessList = async (filters: IFilters) => {
  const response = await get('super-admin/business/list', filters)
  return response
}
export const getBusinessBookingCount = async (businessID: IBusinessIdParam) => {
  const response = await get(`super-admin/business/${businessID.businessId}/booking-count`)
  return response
}
export const updateBusinessStatus = async (businessParams: IBusinessStatusParams) => {
  const response = await put('super-admin/business/update-status', {
    business_id: businessParams.businessId,
    status: businessParams.status,
  })
  return response
}

export const deleteBusiness = async (id: number) => {
  const response = await _delete(`/super-admin/business/${id}`)

  return response
}
